import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencil: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPencil"><Path d="M13.5 6L17 2.5L21.5 7L18 10.5L7 21.5H2.5V17L13.5 6Z" stroke="currentColor" strokeLinecap="round"/><Path d="M13.5 6L18 10.5" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconPencil;
